<template>
  <div class="core-competency">
    
    <div class="content">
      <img :src="imageSrc" :alt="title" class="core-image">
      <div class="text-content">
        <h2>{{ title }}</h2>
        <p class="sentimental-sentence">{{ sentimentalSentence }}</p>
        <p>{{ description }}</p>
        <p>See projects tagged <ProjectTagLink :tagText="tag">🔥{{ title }}🔥</ProjectTagLink></p>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectTagLink from './ProjectTagLink';
export default {
  name: 'CoreCompetency',
    components: {
    ProjectTagLink
  },
  props: {
    title: String,
    tag: String,
    imageSrc: String,
    sentimentalSentence: String,
    description: String
  }
}
</script>

<style scoped>
.core-competency {
  width: 80%;
  max-width: 1200px;
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 2px solid #ccc;
  padding-bottom: 20px;
}

.core-competency h2 {
  color: red;
  font-size: 2em;
  margin-bottom: 10px;
  width: 100%;
}

.content {
  display: flex;
  align-items: flex-start;
}

.core-competency .core-image {
  max-width: 30%;
  margin-right: 20px;
}

.core-competency .text-content {
  width: 70%;
}

.core-competency .sentimental-sentence {
  font-family: monospace;
  font-size: 1.1em;
  color: red;
  margin-bottom: 10px;
}

.core-competency p {
  font-size: 1em;
  line-height: 1.6;
}
</style>
